import React from 'react';
import './style.scss';
import clsx from 'clsx';

interface Props {
  active: boolean;
  onClick: () => any;
  activeColor?: string;
  inactiveColor?: string;
  className?: string;
}

const MenuButton = ({
  active,
  onClick,
  activeColor,
  inactiveColor,
  className
}: Props) => {
  const color = active ? activeColor : inactiveColor;

  return (
    <div
      className={clsx(
        'menu-button',
        active && 'menu-button-inverted',
        className
      )}
      onClick={onClick}
    >
      <div className='menu-button-row mb-row-between'>
        <Dot color={color} />
        <Dot color={color} className='mb-dot-animated top-center' />
        <Dot color={color} />
      </div>
      <div className='menu-button-row mb-row-center'>
        <Dot color={color} className='mb-dot-animated  middle-left' />
        <Dot color={color} />
        <Dot color={color} className='mb-dot-animated middle-right' />
      </div>
      <div className='menu-button-row mb-row-between'>
        <Dot color={color} />
        <Dot color={color} className='mb-dot-animated bottom-center' />
        <Dot color={color} />
      </div>
    </div>
  );
};

interface DotProps {
  className?: string;
  color?: string;
}

const Dot = ({ className, color }: DotProps) => {
  return <div style={{ background: color }} className={className} />;
};

export default MenuButton;
